new class HeliumForms {
  constructor() {
    CF.ready(()=> {
      this.init()
    })
  }

  init() {
    this.formFields = document.querySelectorAll('.cf-field')

    if (!this.formFields.length) return
  
    this.formFields.forEach((field)=> {
      const input = field.querySelector('input')

      if (!input) return

      if (input.value) {
        this.activeLabels(input)
      } else {
        this.inactiveLabels(input)
      }

      input.addEventListener('input', (el) => {
        this.activeLabels(el)
      })

      input.addEventListener('focus', (el)=> {
        this.activeLabels(el)
      })

      input.addEventListener('focusout', (el)=> {
        this.inactiveLabels(el)
      })
    })
  }

  activeLabels(el) {
    el = el.target || el
    const field = el.closest('.cf-field')
    if (field) {
      field.classList.add('active');
    }
    
    const previous = el.previousSibling;
    if (previous) {
      previous.classList.add('active');
    }
  }

  inactiveLabels(el) {
    el = el.target || el
    if (el.value.length < 1) {
      const field = el.closest('.cf-field')
      if (field) {
        field.classList.remove('active');
      }
      const previous = el.previousSibling;
      if (previous?.classList) {
        previous.classList.remove('active');
      }
    }
  }
}